export default __webpack_public_path__ + "static/media/globe.d1c65829.gif";